import { defineStore } from 'pinia';

export interface GuestDataMetadata {
  version: number;
  updatedAt: string;
}

export interface GuestDataState {
  metadata: GuestDataMetadata;
}

export const useGuestDataStore = defineStore('guestData', {
  state: (): GuestDataState => ({
    metadata: {
      version: 0,
      updatedAt: new Date(0).toISOString(),
    },
  }),
  getters: {
    getVersion(): number {
      return this.metadata.version;
    },
    getUpdatedAt(): string {
      return this.metadata.updatedAt;
    },
  },
  actions: {
    setMetadata(metadata: GuestDataMetadata): void {
      this.metadata = metadata;
    },
  },
});
